import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { getMe } from '../api/getMe';
import { UserService } from '../service/UserService';

const auth = {
  me: () =>
    queryOptions({
      queryKey: ['me'],
      queryFn: getMe,
    }),
};

const useUpdateUserMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: Parameters<typeof UserService.updateUser>[0]) =>
      UserService.updateUser(body),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: auth.me().queryKey });
    },
  });
};

export { auth, useUpdateUserMutation };
